import Model from "./model";

export default new Model({
  resource: "rol",
  varName:'roles',
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"name", default:"-", required: true, type:"text", width: 100},
    {label:"Title", nameAttr:"title", default:"-", required: true, type:"text", width: 100},
    //{label:"abilities", nameAttr:"abilities", default:null, required: true, type:"multiselect", model:"abilityModel"},
  ]
});
